import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { EpsiOrders } from '../../epsi/orders/EpsiOrders';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejEpsiOrderListPage = () => {
  const { apps, vydej } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej && vydej?.modules?.epsi ? (
        <AppWrapper appType={APP_TYPE.VYDEJ} menu={<VydejMenu />}>
          <EpsiOrders />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejEpsiOrderListPage;
